// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3a53c45a","453":"67bbc44f","732":"36db8a4a"}[chunkId] + ".chunk.js";
};